import {Link, useLocation} from "react-router-dom";

const DesktopLink = ({item}) => {
    const location = useLocation();

    const href = item.href;
    const title = item.title;
    const isActive = location.pathname === href;

    return (
        <div className="desktop-menu-link-group">
            <Link
                key={title}
                to={href}
                className={`${isActive ? 'desktop-menu-link active' : 'desktop-menu-link'}`}
            >
                {title}
                {item.subItems && (
                    <svg className="desktop-menu-link-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                         width="24" height="24">
                        <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/>
                    </svg>
                )}
            </Link>
            {item.subItems && (
                <div className="desktop-submenu-wrapper">
                    <div className="desktop-submenu-container">
                    {item.subItems.map((subItem) => (
                            <Link
                                key={subItem.title}
                                to={subItem.href}
                                className="desktop-submenu-link"
                            >
                                {subItem.title}
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default DesktopLink;